<p-dialog [(visible)]="visivel"
          [modal]="true"
          [closable]="true"
          [draggable]="false"
          [style]="{ width: '50rem' }"
          [showHeader]="false"
          styleClass="dialog-wave-redesign"
          (onShow)="onShow()"
          (onHide)="onHide()">

  <p-toast position="top-right"></p-toast>

  <!-- ============================================================ -->
  <!-- TELA 1: Lista de Grupos (quando nao esta editando) -->
  <!-- ============================================================ -->
  <ng-container *ngIf="!grupoSelecionado && !novoGrupo">
    <!-- Wave Header -->
    <div class="dialog-wave-header">
      <div class="dialog-wave-header-content">
        <div class="dialog-wave-icon-container">
          <i class="pi pi-sliders-h" aria-hidden="true"></i>
        </div>
        <div class="dialog-wave-header-text">
          <h2>{{ texts.titulo }}</h2>
          <p>{{ texts.descricao }}</p>
        </div>
      </div>
      <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
      <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
      <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
      </svg>
    </div>

    <div class="p-4">
      <!-- Barra de busca + botao novo -->
      <div class="flex align-items-center gap-2 mb-3">
        <span class="p-input-icon-left flex-1">
          <i class="pi pi-search"></i>
          <input pInputText [(ngModel)]="filtroTexto" [placeholder]="texts.buscar" class="w-full" />
        </span>
        <button pButton type="button" [label]="texts.novo_grupo" icon="pi pi-plus"
                class="p-button-sm btn-primary white-space-nowrap"
                (click)="iniciarNovoGrupo()">
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="loadingGrupos" class="flex justify-content-center p-4">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4"></p-progressSpinner>
      </div>

      <!-- Lista vazia -->
      <div *ngIf="!loadingGrupos && gruposFiltrados.length === 0" class="text-center p-4">
        <i class="pi pi-inbox text-400 text-4xl mb-2"></i>
        <p class="text-500">{{ texts.nenhum_grupo }}</p>
      </div>

      <!-- Lista de grupos -->
      <div *ngIf="!loadingGrupos && gruposFiltrados.length > 0" class="flex flex-column gap-2">
        <div *ngFor="let grupo of gruposFiltrados; trackBy: trackByGrupoId"
             class="flex align-items-center gap-3 p-3 surface-50 border-round-lg grupo-list-item cursor-pointer"
             (click)="editarGrupo(grupo)">

          <!-- Checkbox associacao -->
          <p-checkbox [ngModel]="isAssociado(grupo.id)"
                      [binary]="true"
                      (click)="$event.stopPropagation()"
                      (onChange)="toggleAssociacao(grupo)">
          </p-checkbox>

          <!-- Nome do grupo -->
          <span class="flex-1 font-medium text-900">{{ grupo.nome }}</span>

          <!-- Badge obrigatorio/opcional -->
          <p-badge [value]="grupo.obrigatorio ? texts.obrigatorio : texts.opcional"
                   [severity]="grupo.obrigatorio ? 'danger' : 'info'"
                   styleClass="text-xs">
          </p-badge>

          <!-- Quantidade de opcoes -->
          <small class="text-500 white-space-nowrap">{{ grupo.opcoes.length || 0 }} {{ texts.opcoes }}</small>

          <!-- Botao editar -->
          <button pButton type="button" icon="pi pi-pencil"
                  class="p-button-rounded p-button-text p-button-sm"
                  (click)="$event.stopPropagation(); editarGrupo(grupo)">
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-content-end gap-2 p-4 border-top-1 surface-border">
      <button pButton [label]="texts.cancelar" (click)="onHide()"
              severity="secondary" class="p-button-text"></button>
    </div>
  </ng-container>

  <!-- ============================================================ -->
  <!-- TELA 2: Edicao de Grupo (novo ou existente) -->
  <!-- ============================================================ -->
  <ng-container *ngIf="grupoSelecionado || novoGrupo">
    <!-- Wave Header -->
    <div class="dialog-wave-header">
      <div class="dialog-wave-header-content">
        <div class="dialog-wave-icon-container">
          <i class="pi pi-cog" aria-hidden="true"></i>
        </div>
        <div class="dialog-wave-header-text">
          <h2>{{ novoGrupo ? texts.novo_grupo : texts.editar_grupo }}</h2>
          <p *ngIf="grupoSelecionado">{{ grupoSelecionado.nome }}</p>
        </div>
      </div>
      <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
      <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
      <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
      </svg>
    </div>

    <div class="p-4">
      <!-- Campos do grupo -->
      <div class="grid mb-3">
        <div class="col-12">
          <label class="font-bold text-sm text-700 mb-1 block">{{ texts.nome_grupo }}</label>
          <input pInputText [(ngModel)]="grupoForm.nome" class="w-full" />
        </div>
        <div class="col-12 flex align-items-center gap-2 mt-2">
          <p-inputSwitch [(ngModel)]="grupoForm.obrigatorio"></p-inputSwitch>
          <span class="text-sm text-700">{{ texts.obrigatorio }}</span>
        </div>
        <div class="col-6 mt-2">
          <label class="font-bold text-sm text-700 mb-1 block">{{ texts.minimo_selecoes }}</label>
          <p-inputNumber [(ngModel)]="grupoForm.minimoSelecoes" [min]="0"
                         styleClass="w-full" inputStyleClass="border-round-lg">
          </p-inputNumber>
        </div>
        <div class="col-6 mt-2">
          <label class="font-bold text-sm text-700 mb-1 block">{{ texts.maximo_selecoes }}</label>
          <p-inputNumber [(ngModel)]="grupoForm.maximoSelecoes" [min]="1"
                         styleClass="w-full" inputStyleClass="border-round-lg">
          </p-inputNumber>
        </div>
      </div>

      <!-- Opcoes do grupo (apenas para grupo existente) -->
      <div *ngIf="grupoSelecionado" class="mt-3">
        <div class="flex align-items-center gap-2 mb-2">
          <span class="text-900 font-bold text-sm">{{ texts.opcoes_titulo }}</span>
          <p-badge *ngIf="grupoSelecionado.opcoes.length > 0"
                   [value]="grupoSelecionado.opcoes.length + ''"
                   severity="info"></p-badge>
        </div>

        <!-- Lista de opcoes com drag & drop -->
        <div *ngIf="grupoSelecionado.opcoes.length > 0"
             cdkDropList
             (cdkDropListDropped)="onDropOpcao($event)"
             class="flex flex-column gap-2">

          <div *ngFor="let opcao of grupoSelecionado.opcoes; trackBy: trackByOpcaoId"
               cdkDrag
               class="opcao-item p-2 surface-50 border-round-lg">

            <div class="flex align-items-center gap-2">
              <div class="drag-handle-sm" cdkDragHandle aria-label="Arrastar para reordenar">
                <i class="pi pi-ellipsis-v"></i>
                <i class="pi pi-ellipsis-v"></i>
              </div>

              <input pInputText [(ngModel)]="opcao.nome" class="flex-1 text-sm" />

              <p-inputNumber [(ngModel)]="opcao.precoAdicional" mode="decimal"
                             [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                             [minFractionDigits]="2" [maxFractionDigits]="2"
                             styleClass="w-7rem" inputStyleClass="border-round-lg text-sm text-center">
              </p-inputNumber>

              <p-inputSwitch [(ngModel)]="opcao.visivel" [pTooltip]="texts.visivel"></p-inputSwitch>

              <button pButton type="button" icon="pi pi-save"
                      class="p-button-rounded p-button-text p-button-success p-button-sm"
                      (click)="salvarOpcao(opcao)">
              </button>

              <button pButton type="button" icon="pi pi-trash"
                      class="p-button-rounded p-button-text p-button-danger p-button-sm"
                      (click)="removerOpcao(opcao)">
              </button>
            </div>

            <!-- Campos extras (custo, desconto, sku) - sempre visiveis -->
            <div class="grid mt-2 ml-4">
              <div class="col-4">
                <label class="text-xs text-500 block mb-1">{{ texts.custo }}</label>
                <p-inputNumber [(ngModel)]="opcao.custo" mode="decimal"
                               [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                               [minFractionDigits]="2" [maxFractionDigits]="2"
                               styleClass="w-full" inputStyleClass="border-round-lg text-xs">
                </p-inputNumber>
              </div>
              <div class="col-4">
                <label class="text-xs text-500 block mb-1">{{ texts.desconto }}</label>
                <p-inputNumber [(ngModel)]="opcao.desconto" mode="decimal"
                               suffix="%" [min]="0" [max]="100"
                               [minFractionDigits]="0" [maxFractionDigits]="2"
                               styleClass="w-full" inputStyleClass="border-round-lg text-xs">
                </p-inputNumber>
              </div>
              <div class="col-4">
                <label class="text-xs text-500 block mb-1">{{ texts.sku }}</label>
                <input pInputText [(ngModel)]="opcao.sku" class="w-full text-xs" />
              </div>
            </div>
          </div>
        </div>

        <!-- Formulario nova opcao -->
        <div *ngIf="novaOpcao" class="p-3 surface-100 border-round-lg mt-2">
          <div class="flex align-items-center gap-2 mb-2">
            <input pInputText [(ngModel)]="novaOpcao.nome" [placeholder]="texts.nome_opcao" class="flex-1 text-sm" />
            <p-inputNumber [(ngModel)]="novaOpcao.precoAdicional" mode="decimal"
                           [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                           [minFractionDigits]="2" [maxFractionDigits]="2"
                           styleClass="w-7rem" inputStyleClass="border-round-lg text-sm text-center">
            </p-inputNumber>
          </div>
          <div class="grid mb-2">
            <div class="col-4">
              <label class="text-xs text-500 block mb-1">{{ texts.custo }}</label>
              <p-inputNumber [(ngModel)]="novaOpcao.custo" mode="decimal"
                             [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                             [minFractionDigits]="2" [maxFractionDigits]="2"
                             styleClass="w-full" inputStyleClass="border-round-lg text-xs">
              </p-inputNumber>
            </div>
            <div class="col-4">
              <label class="text-xs text-500 block mb-1">{{ texts.desconto }}</label>
              <p-inputNumber [(ngModel)]="novaOpcao.desconto" mode="decimal"
                             suffix="%" [min]="0" [max]="100"
                             [minFractionDigits]="0" [maxFractionDigits]="2"
                             styleClass="w-full" inputStyleClass="border-round-lg text-xs">
              </p-inputNumber>
            </div>
            <div class="col-4">
              <label class="text-xs text-500 block mb-1">{{ texts.sku }}</label>
              <input pInputText [(ngModel)]="novaOpcao.sku" class="w-full text-xs" />
            </div>
          </div>
          <div class="flex justify-content-end gap-2">
            <button pButton type="button" [label]="texts.cancelar"
                    class="p-button-text p-button-sm"
                    (click)="cancelarNovaOpcao()">
            </button>
            <button pButton type="button" [label]="texts.salvar" icon="pi pi-check"
                    class="p-button-sm btn-primary"
                    [disabled]="!novaOpcao.nome?.trim()"
                    (click)="salvarNovaOpcao()">
            </button>
          </div>
        </div>

        <!-- Botao adicionar opcao -->
        <button *ngIf="!novaOpcao" pButton type="button"
                [label]="texts.adicionar_opcao"
                icon="pi pi-plus"
                class="p-button-text p-button-sm mt-2"
                (click)="iniciarNovaOpcao()">
        </button>
      </div>
    </div>

    <!-- Footer edicao -->
    <div class="flex justify-content-between p-4 border-top-1 surface-border">
      <div class="flex gap-2">
        <button pButton [label]="texts.voltar" icon="pi pi-arrow-left"
                class="p-button-text" (click)="voltarParaLista()">
        </button>
        <button *ngIf="grupoSelecionado" pButton [label]="texts.excluir" icon="pi pi-trash"
                class="p-button-danger p-button-text"
                (click)="excluirGrupo()">
        </button>
      </div>
      <button pButton [label]="texts.salvar" icon="pi pi-check"
              class="btn-primary"
              [loading]="salvandoGrupo"
              [disabled]="!grupoForm.nome?.trim()"
              (click)="salvarGrupo()">
      </button>
    </div>
  </ng-container>
</p-dialog>
